<template>
  <div class="p-col-12">
    <page-header title="forms.budget-configuration.title"/>
    <form @submit.prevent="save">

      <card :header="$t('forms.budget-configuration.card-title-budget-configuration')" class="p-col-12">
        <coff-input-text v-model="form.name" label="forms.budget-configuration.name" class="p-col-12 p-md-6 p-lg-4" :error="validation.name" />
        <coff-input-number v-model="form.pageToEdit" label="forms.budget-configuration.pageToEdit" class="p-col-12 p-md-6 p-lg-4" :error="validation.pageToEdit" :minFractionDigits="0" />
        <coff-input-number v-model="form.startHorizontalPoint" label="forms.budget-configuration.startHorizontalPoint" class="p-col-12 p-md-6 p-lg-4" :error="validation.startHorizontalPoint" :minFractionDigits="0" />
        <coff-input-number v-model="form.startColumn1Point" label="forms.budget-configuration.startColumn1Point" class="p-col-12 p-md-6 p-lg-4" :error="validation.startColumn1Point" :minFractionDigits="0" />
        <coff-input-number v-model="form.startColumn2Point" label="forms.budget-configuration.startColumn2Point" class="p-col-12 p-md-6 p-lg-4" :error="validation.startColumn2Point" :minFractionDigits="0" />
        <coff-input-number v-model="form.startColumn3Point" label="forms.budget-configuration.startColumn3Point" class="p-col-12 p-md-6 p-lg-4" :error="validation.startColumn3Point" :minFractionDigits="0" />
        <coff-input-number v-model="form.startColumn4Point" label="forms.budget-configuration.startColumn4Point" class="p-col-12 p-md-6 p-lg-4" :error="validation.startColumn4Point" :minFractionDigits="0" />
        <coff-input-number v-model="form.fontSize" label="forms.budget-configuration.fontSize" class="p-col-12 p-md-6 p-lg-4" :error="validation.fontSize" :minFractionDigits="0" />
        <coff-input-text v-model="form.rgbFontColor" label="forms.budget-configuration.rgbFontColor" class="p-col-12 p-md-6 p-lg-4" :error="validation.rgbFontColor" />
        <card :header="$t('forms.budget-configuration.mentoring-values')" class="p-col-12" >
          <coff-input-money v-model="form.value1Person" label="forms.budget-configuration.value1Person" class="p-col-12 p-md-6 p-lg-4" :error="validation.value1Person" />
          <coff-input-money v-model="form.value2Person" label="forms.budget-configuration.value2Person" class="p-col-12 p-md-6 p-lg-4" :error="validation.value2Person" />
          <coff-input-money v-model="form.value3Person" label="forms.budget-configuration.value3Person" class="p-col-12 p-md-6 p-lg-4" :error="validation.value3Person" />
          <coff-input-money v-model="form.value4Person" label="forms.budget-configuration.value4Person" class="p-col-12 p-md-6 p-lg-4" :error="validation.value4Person" />
          <coff-input-money v-model="form.value5Person" label="forms.budget-configuration.value5Person" class="p-col-12 p-md-6 p-lg-4" :error="validation.value5Person" />
          <coff-input-money v-model="form.value6Person" label="forms.budget-configuration.value6Person" class="p-col-12 p-md-6 p-lg-4" :error="validation.value6Person" />
          <coff-input-money v-model="form.value7Person" label="forms.budget-configuration.value7Person" class="p-col-12 p-md-6 p-lg-4" :error="validation.value7Person" />
          <coff-input-money v-model="form.value8Person" label="forms.budget-configuration.value8Person" class="p-col-12 p-md-6 p-lg-4" :error="validation.value8Person" />
          <coff-input-money v-model="form.value9Person" label="forms.budget-configuration.value9Person" class="p-col-12 p-md-6 p-lg-4" :error="validation.value9Person" />
          <coff-input-money v-model="form.value10Person" label="forms.budget-configuration.value10Person" class="p-col-12 p-md-6 p-lg-4" :error="validation.value10Person" />
        </card>
        <div class="p-col-12">
          <label><b>{{ $t('forms.budget-configuration.pdfFile') }}</b></label>
          <FileUpload mode="basic" accept="application/pdf" :maxFileSize="10000000" @select="onFileSelect" :customUpload="true" :chooseLabel="$t('forms.budget-configuration.choosePdfFile')" />
          <div v-if="form.pdfFileName" class="p-mt-2">
            <span>{{ form.pdfFileName }}</span>
            <Button icon="pi pi-times" class="p-button-text p-button-danger p-ml-2" @click="removePdfFile" />
          </div>
        </div>
        <div class="p-col-12">
          <Button :label="$t('btn.save&continue')" class="p-button-success" style="float: right;"/>
        </div>
      </card>

    </form>
  </div>
</template>

<script>

import ValidationUtils from "@/utils/ValidationUtils";
import ToastMessageBusiness from "@/business/ToastMessageBusiness";
import BudgetConfigurationBusiness from "@/business/BudgetConfigurationBusiness";
import PageHeader from "@/components/page/PageHeader";
import EventBus from "@/commons/EventBus";

export default {
  name: "BudgetConfigurationForm",
  components: {PageHeader},
  data(){
    return {
      form: {},
      validation: {
        name: false,
        pageToEdit: false,
        startHorizontalPoint: false,
        startColumn1Point: false,
        startColumn2Point: false,
        startColumn3Point: false,
        startColumn4Point: false,
        fontSize: false,
        rgbFontColor: false,
        value1Person: false,
        value2Person: false,
        value3Person: false,
        value4Person: false,
        value5Person: false,
        value6Person: false,
        value7Person: false,
        value8Person: false,
        value9Person: false,
        value10Person: false,
      },
    }
  },

  async mounted(){
    const id = this.$route.params.id;
    if(id){
      EventBus.loadingPage(true);
      this.form =  {... await BudgetConfigurationBusiness.getById(id)};
      EventBus.loadingPage(false);
    }
  },

  methods: {

    async save(){
      this.validation = ValidationUtils.basicValidation(this.validation, this.form);
      if(!this.validation.erros){
        const response = await BudgetConfigurationBusiness.save(this.form, this.form.id).catch((e) => ToastMessageBusiness.showError(e.message));
        if(response){
          this.form.id = response.id;
          ToastMessageBusiness.showSuccess();
        }
      }
    },

    forceUpdateField(field, value){
      this.$set(this.form, field, value);
    },

    onFileSelect(event){
      const file = event.files[0];
      if(file){
        const reader = new FileReader();
        reader.onload = (e) => {
          const base64String = e.target.result.split(',')[1]; // Remove data:application/pdf;base64, prefix
          this.$set(this.form, 'pdfFileBase64', base64String);
          this.$set(this.form, 'pdfFileName', file.name);
        };
        reader.readAsDataURL(file);
      }
    },

    removePdfFile(){
      this.$set(this.form, 'pdfFileBase64', null);
      this.$set(this.form, 'pdfFileName', null);
    },

  }

}
</script>

<style scoped>

</style>
